<template lang="pug">
  .step-badge
    p.step-badge-title {{ stepLabel }}
</template>

<style lang="scss" scoped>
.step-badge {
  width: 64px;
  height: 20px;
  background-color: $color-step-badge;
  border-radius: 4px;
  text-align: center;

  p {
    margin: 0;
    padding: 0;
  }
  .step-badge-title {
    @extend %stepbadge-text;
    margin: 1px 0;
  }
}
</style>

<script>
export default {
  props: {
    number: { type: Number, required: true },
  },
  computed: {
    stepLabel() {
      return `STEP ${('00' + this.number).substr(-2)}`
    },
  },
}
</script>
